import parkPilotLogoPng from "../images/ParkPilotLogo.PNG";
import parkPilotClassicJpg from "../images/parkPilot.jpg";
import parkPilotBlueJpg from "../images/parkPilotBlue.jpg";
import logoSmallJpg from "../images/logosmall.jpg";

const logoAliasEntries = [
    ["/images/parkpilotlogo.png", parkPilotLogoPng],
    ["/images/parkpilot.jpg", parkPilotClassicJpg],
    ["/images/parkpilotblue.jpg", parkPilotBlueJpg],
    ["/images/logosmall.jpg", logoSmallJpg],
    ["parkpilotlogo.png", parkPilotLogoPng],
    ["parkpilot.jpg", parkPilotClassicJpg],
    ["parkpilotblue.jpg", parkPilotBlueJpg],
    ["logosmall.jpg", logoSmallJpg],
];

const logoAliasMap = new Map(logoAliasEntries);

export const presetLogos = [
    { label: "None", value: "" },
    { label: "ParkPilot Blue", value: "/images/parkPilotBlue.jpg" },
    { label: "ParkPilot Classic", value: "/images/parkPilot.jpg" },
    { label: "Logo Small", value: "/images/logosmall.jpg" },
    { label: "Logo PNG", value: "/images/ParkPilotLogo.PNG" },
];

export function resolveBrandLogoUrl(rawUrl) {
    const value = String(rawUrl || "").trim();
    if (!value) return "";

    const lower = value.toLowerCase();

    // Keep explicit remote/data/blob URLs untouched.
    if (lower.startsWith("http://") || lower.startsWith("https://") || lower.startsWith("data:") || lower.startsWith("blob:")) {
        return value;
    }

    const normalized = lower.startsWith("/") ? lower : `/${lower}`;
    const aliasMatch = logoAliasMap.get(lower) || logoAliasMap.get(normalized);

    return aliasMatch || value;
}
